<template>
  <div>
    <p class="title is-3-desktop is-4-tablet is-5-mobile">
      Pedidos de Materiales
    </p>

    <section>

      <div class="block">
        <b-radio v-model="radioStatus" native-value="all">
          Todos los estados
        </b-radio>
        <b-radio v-model="radioStatus" native-value="pen"> Pendientes </b-radio>

        <b-radio v-model="radioStatus" native-value="env"> Enviados </b-radio>

        <b-radio v-model="radioStatus" native-value="recep"> Recepcionado </b-radio>

        <b-radio v-model="radioStatus" native-value="can"> Cancelados </b-radio>
      </div>

      <a @click="openModalRegisterSolicitudMaterial" class="button is-info">Nueva Solicitud</a>
      <a @click="cargarPedidos"   class="button is-success">Consultar</a>
    </section>

    <section style="margin-top: 30px">
      <b-table
        :data="ordersMaterial.content"
        :hoverable="true"
        :mobile-cards="true"

        :opened-detailed="defaultOpenedDetails"
        detailed
        detail-key="id"


        paginated
        backend-pagination
        :total="ordersMaterial.totalElements"
        :per-page="searchOptions.perPage"
        @page-change="onPageChange"
        backend-sorting
        :default-sort-direction="defaultSortOrder"
        :default-sort="[searchOptions.sortField, searchOptions.sortOrder]"
        :current-page="searchOptions.pageNumber"
        @sort="onSort"
      >
        <template slot-scope="props">
          <b-table-column label="Responsable" class="is-size-7">
            {{ props.row.userName }}
          </b-table-column>


          <b-table-column label="Observación" class="is-size-7">
            {{ props.row.observation}}
          </b-table-column>

          <b-table-column label="Dirección" class="is-size-7">
            {{ props.row.deliveryAddress}}
          </b-table-column>

          <b-table-column label="Número Orden" class="is-size-7">
            {{ props.row.numberOrder}}
          </b-table-column>

          <b-table-column label="Estado" class="is-size-7">
            <b-tag :type="getClassStatusOrder(props.row.status)">{{props.row.status | StatusOrderConvert}}</b-tag>
          </b-table-column>

          <b-table-column label="Acciones" centered>
            <b-tooltip v-if="props.row.status =='pen' || props.row.status =='can' "
              type="is-dark"
              label="Cancelar pedido"
              position="is-left"
            >
              <button
                @click="doCancelOrderDialog(props.row)"
                class="button is-small"
                :disabled="getDisableButtonOptions(props.row.status)"
              >
                <b-icon
                  type="is-danger"
                  size="is-mediun"
                  icon="cancel"
                ></b-icon>
              </button>
            </b-tooltip>

            <b-tooltip v-else-if="props.row.status =='env'"
              type="is-dark"
              label="Recepcionar pedido"
              position="is-left"
            >
              <button
                @click="doconfirmarRecepcion(props.row)"
                class="button is-small"
                :disabled="isValidoRecepcionar"
              >
                <b-icon
                  type="is-success"
                  size="is-mediun"
                  icon="check"
                ></b-icon>
              </button>
            </b-tooltip>
            <!-- <b-tooltip  type="is-dark" label="Descargar pedido"
                        position="is-left">
              <button @click="doDownloadOrder(props.row)" class="button is-small"><b-icon type="is-success" size="is-mediun" icon="download"></b-icon></button>
            </b-tooltip> -->
          </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">

          <b-field label="Materiales">
            <b-table
              :data="props.row.materiales"
              :bordered="false"
              :striped="true"
              :narrowed="true"
              :hoverable="true"
              :loading="false"
              :mobile-cards="true"
              :sortable="false">

              <template slot-scope="propss">

                 <!-- <b-table-column  label="Id" >
                  {{ propss.row.id }}
                </b-table-column> -->

                <b-table-column  label="Tipo Material" >
                  {{ propss.row.name }}
                </b-table-column>

                <b-table-column label="Código Barra"   class="is-size-7">
                 <div v-if="propss.row.barCode">
                  Si
                </div>
                <div v-else>
                  No
                </div>
                </b-table-column>

                <b-table-column  label="Cantidad" >
                  {{ propss.row.cantidad }}
                </b-table-column>

                <b-table-column label="Descripción" width="200"  class="is-size-7">
                  {{ propss.row.description }}
               </b-table-column>

                <b-table-column  label="N° Código Barras" >
                  {{ propss.row.code }}
                </b-table-column>

                <b-table-column v-if="props.row.status =='env' || props.row.status =='recep'"   label="Observación" >
                  <b-input
                      :disabled="props.row.status =='recep'"
                      placeholder="Opcional"
                      v-model="propss.row.observation"
                    ></b-input>
                </b-table-column>

                <b-table-column v-if="props.row.status =='env' || props.row.status =='recep' "  label="Recepcionado?" >
                  <b-field>
                      <b-checkbox @input="validarItemRecepcionar(props.row.materiales)"
                      :disabled="props.row.status =='recep'"
                      v-model="propss.row.recepcionado">
                      </b-checkbox>
                  </b-field>
                </b-table-column>

                 <b-table-column v-if="props.row.status =='pen'"  label="Acciones" >

                  <b-tooltip type="is-dark" label="Eliminar Material" position="is-left">
                    <button :disabled="getDisableButtonOptions(props.row.status)"  @click="deleteItemOrdenMaterialDialog(props.row.id,propss.row.id)" class="button is-small"><b-icon type="is-danger" size="is-mediun" icon="delete"></b-icon></button>
                  </b-tooltip>
                </b-table-column>

              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon
                        icon="emoticon-sad"
                        size="is-large">
                      </b-icon>
                    </p>
                    <p>No hay archivos agregados.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </b-field>


        </template>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
              </p>
              <p>Ninguna Solicitud Registrada.</p>
            </div>
          </section>
        </template>
      </b-table>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Util from '../util'
const RegisterSolicitudMaterial = () => import("../components/modal/RegisterSolicitudMaterial");
export default {
  data() {
    return {
      ordersMaterial: [],
      radioAllOwn: "all",
      radioStatus: "all",
      searchOptions: {
        perPage: 10,
        pageNumber: 1,
        sortField: "orderDate",
        sortOrder: "desc",
      },
      defaultSortOrder: "desc",
      defaultOpenedDetails: [1],
      isValidoRecepcionar: true
    };
  },
  methods: {
    ...mapActions({'loadOrdersMateriales': 'materiales/loadOrdersMateriales', 'deleteItemOrderMaterial': "materiales/deleteItemOrderMaterial",
    'cancelOrderMaterial': 'materiales/cancelOrderMaterial','recepcionarOrderMaterial': 'materiales/recepcionarOrderMaterial'}),

     loadNameUserById(idUser){
      return Util.getUserById(idUser).person.firstName + ' '+Util.getUserById(idUser).person.lastName
      },

    openModalRegisterSolicitudMaterial() {
      this.$modal.open({
        parent: this,
        component: RegisterSolicitudMaterial,
        hasModalCard: true,
        props: { cargarPedidos:this.cargarPedidos }
      });
    },

     onSort(field, order) {
        this.searchOptions.sortField = field
        this.searchOptions.sortOrder = order
        this.cargarPedidos()
      },


    onPageChange(page) {
        this.searchOptions.pageNumber = page
        this.cargarPedidos()
      },

    cargarPedidos(){
        let payload=null
        let idUser = this.radioAllOwn=='all'?null:Util.getAuth().idUser
        let idAddress = Util.getUser().idAddress;
        let status = this.radioStatus=='all'?null:this.radioStatus

        var paramsArray = [
          `idAddress=${idAddress}`,
          `pageNumber=${this.searchOptions.pageNumber}`,
          `perPage=${this.searchOptions.perPage}`,
          `sortField=${this.searchOptions.sortField}`,
          `sortOrder=${this.searchOptions.sortOrder}`,
          `isPageable=${true}`,
        ]

        if (idUser && idUser!='all')
          paramsArray.push(`idUser=${idUser}`)

        if(status && status!='all')
          paramsArray.push(`status=${status}`)

        const params = paramsArray.join('&')

        payload= {context:this, idClient: Util.getAuth().idClient, params:params}

        this.loadOrdersMateriales(payload).then(data=>{
           this.ordersMaterial=data
        })
          .catch((error)=>{
            this.orderList=[]
          })

      },

      getClassStatusOrder(value) {
        if (!value) return ''
        if (value==='pen' || value==='envobs' || value==='entobs')
          return 'is-warning'
        else if(value==='apr' || value==='env')
          return 'is-info'
        else if(value==='recep')
          return 'is-success'
        else if(value==='can')
          return 'is-danger'
        else return ''
      },

       getDisableButtonOptions(value) {
        if (!value) return true
        if (value==='pen'){
          return false
        }else{
          return true;
        }

      },

      deleteItemOrdenMaterialDialog( idOrderMaterial,idTipoMaterial){
         this.$dialog.confirm({
          title: 'Eliminar Material',
          message: 'Está seguro que quiere <b>eliminar</b> el item seleccionado?',
          confirmText: 'Si',
          cancelText: 'No',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.deleteItemOrdenMaterial(idOrderMaterial,idTipoMaterial)
        })


    },

    deleteItemOrdenMaterial(idOrderMaterial,idTipoMaterial){
      this.deleteItemOrderMaterial({context:this, idOrderMaterial: idOrderMaterial, idTipoMaterial:idTipoMaterial}).then(()=>{
        this.cargarPedidos();
      });
    },


    doCancelOrderDialog(item){

        this.$dialog.confirm({
          title: 'Cancelar Order',
          message: 'Está seguro que quiere <b>cancelar</b> el orden <b>'+ item.numberOrder+'</b>?',
          confirmText: 'Si',
          cancelText: 'No',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.doCancelOrder(item)
        })
    },

    doCancelOrder(item){
       this.cancelOrderMaterial({context:this, idOrderMaterial: item.id}).then(()=>{
        this.cargarPedidos();
      });
    },

    doconfirmarRecepcion(item){

        this.$dialog.confirm({
          title: 'Confirmar Entrega',
          message: 'Está seguro que quiere <b>Confirmar la recepción</b> la orden <b>'+ item.numberOrder+'</b>?',
          confirmText: 'Si',
          cancelText: 'No',
          type: 'is-success',
          hasIcon: true,
          onConfirm: () => this.confirmarRecepcion(item)
        })
    },

    confirmarRecepcion(item){
       this.recepcionarOrderMaterial({context:this, orderMaterial: item}).then(()=>{
        this.cargarPedidos();
      });
    },

    validarItemRecepcionar(item){
      let materiales= item
      console.log(materiales);
      for (let index = 0; index < materiales.length; index++) {
        const element = materiales[index].recepcionado;
        const tipoMaterial = materiales[index].name;
        if(element && tipoMaterial==='VALIJA' ){
          this.isValidoRecepcionar=false;
          break
        }else{
          this.isValidoRecepcionar=true;
        }
      }
    }

  },
  computed: {
    ...mapGetters({
      getClient: "auth/getClient",
    }),




  },
  mounted(){
      this.cargarPedidos()
  },

  created(){



  }
};
</script>




// WEBPACK FOOTER //
// src/components/SolicitudMateriales.vue